import { Component, OnInit, ViewChild } from '@angular/core';
import { ProcesiService } from './procesi.service';
import { Router } from '@angular/router';
import notify from 'devextreme/ui/notify';
import { moduli } from '../../config';
import moment from 'moment';
import { DxDataGridComponent } from 'devextreme-angular';

@Component({
  selector: 'app-procesi',
  templateUrl: './procesi.component.html',
  styleUrls: ['./procesi.component.scss'],
  providers: [ProcesiService],
})
export class ProcesiComponent implements OnInit {
  @ViewChild(DxDataGridComponent, { static: false })
  dataGrid: DxDataGridComponent;

  sviProizvodi: any;
  odabraniProizvod: any;
  procesi = [];
  oznacenRed: number;
  aktivan: number;

  // PRAVA KORISNIKA
  pravaKorisnika = JSON.parse(sessionStorage.getItem('pravakorisnika'));
  trenutniPogled: any;
  pravaZaTrenutniPogled: any;
  prikaziStranicu = 0;
  // KRAJ PRAVA KORISNIKA

  constructor(private service: ProcesiService, private router: Router) {
    if (parseInt(localStorage.getItem('firma')) == 3) {
      this.router.navigate(['/dostavnica-hlad']);
    }

    // PRAVA KORISNIKA
    this.trenutniPogled = moduli().proizvodProcesi;
    for (var i = 0; i < this.pravaKorisnika.length; i++) {
      //console.log(i);
      if (this.pravaKorisnika[i].smo_ime == this.trenutniPogled) {
        this.pravaZaTrenutniPogled = this.pravaKorisnika[i].sgm_prava;
        //console.log(this.pravaZaTrenutniPogled);
        if (this.pravaKorisnika[i].sgm_prava != 0) {
          this.prikaziStranicu = 1;
        } else {
          notify('Nemate prava.', 'error', 3000);
        }
        return;
      } else {
      }
    }
    // KRAJ PRAVA KORISNIKA
  }

  ngOnInit() {
    this.dohvatiSveProizvode();
  }

  oznaciProces(data) {
    // console.log(data);
    this.oznacenRed = data.rowIndex;
    this.aktivan = data.data.aktivan ? 0 : 1;
    this.dataGrid.instance.cellValue(this.oznacenRed, 'aktivan', this.aktivan);
  }

  spremiPromjene(e) {
    console.log(e);
    let onSaveObject = {
      idartikl: this.odabraniProizvod,
      aktivan: e.data.aktivan,
      rednibroj: e.data.rb,
      idprocesi: e.data.id,
      vrijemetrajanjaoperacije: e.data.vtoum,
      vrijemetrajanjacijelogprocesa: e.data.vtcpum,
      vrijemeradaradnika: e.data.vrrum,
      brojradnikanaoperaciji: e.data.brno,
      cijenaradaradnika: e.data.crrum,
    };
    console.log(onSaveObject);
    this.service.urediProces(onSaveObject).subscribe((res) => {
      console.log(res);
      if (res.success === true) {
        this.dohvatiProcese(this.odabraniProizvod);
        notify('Uspješno dodani podaci!', 'success', 3000);
      } else {
        notify('Došlo je do greške na serveru!', 'error', 3000);
      }
    });
  }

  dohvatiProcese(id) {
    this.procesi = [];
    this.service.dohvatiSveProcese({ idartikl: id }).subscribe((res) => {
      console.log(res);
      for (let proces of res.data) {
        this.procesi.push({
          id: proces.idprocesi,
          rb: proces.pi_rednibroj,
          naziv: proces.ps_naziv,
          aktivan: proces.pi_aktivan,
          brno: proces.pi_brojradnikanaoperaciji,
          crrum: proces.pi_cijenaradaradnika,
          ucrpo: proces.pi_ukupnacijenaradapooperacijama,
          vrrum: proces.pi_vrijemeradaradnika,
          vsrno: proces.pi_vrijemesvihradnikanaoperaciji,
          vtcpum: proces.pi_vrijemetrajanjacijelogprocesa,
          vtoum: proces.pi_vrijemetrajanjaoperacije,
        });
      }
      // console.log(this.procesi);
    });
  }

  dohvatiSveProizvode() {
    this.service.dohvatiSveProizvode({}).subscribe((res) => {
      console.log(res);
      this.sviProizvodi = [];
      for (let data of res.data) {
        this.sviProizvodi.push({
          id: data.ar_id,
          sifra: data.ar_sifra,
          naziv: data.ar_naziv,
          sifraNaziv: data.sifrainaziv,
        });
      }
    });
  }

  odaberiProizvod(e) {
    console.log(e);
    this.odabraniProizvod = e.value;
    if (e.value) {
      this.service.kreirajProces({ idartikl: e.value }).subscribe((res) => {
        console.log(res);
        if (res.success === true) {
          this.dohvatiProcese(e.value);
        }
      });
    }
  }

  onCellPrepared(options) {
    // console.log(options);
    if (
      options.rowType == 'data' &&
      (options.columnIndex == 8 || options.columnIndex == 10)
    ) {
      options.cellElement.classList.add('notEditable');
    }
  }
}
